import 'routie';
import VueRouter from 'vue-router';
import VueRootStore from './Stores/RootStore';
import {Routes} from './Routes';
import getVuePage from './Utils/getVuePage';
import getVueModule from './Utils/getVueModule';
import './Config/Hooks';
import AccessService from "./Services/AccessService";
import {AccessTypes} from "./Constants";
import FeatureToggleService from "Services/FeatureToggleService";
import BillingRouteConfigs from 'Config/BillingRoutes';

const NotFound = async () => (await getVuePage('NotFound')).default;
const KnockoutPage = async () => (await getVuePage('KnockoutPage')).default;

const Scheduler = async () => (await getVuePage('Calendar/Scheduler')).default;
const SchedulerFacilitySettings = async () => (await getVuePage('Calendar/SchedulerAdmin/SchedulerFacilitySettings')).default;
const ColorCodingAdmin = async () => (await getVuePage('Calendar/SchedulerAdmin/ColorCodingAdmin/ColorCodingAdmin')).default;
const BatchPrintDashboard = async () => (await getVuePage('Calendar/BatchPrint/BatchPrintDashboard')).default;
const BatchDischarge = async () => (await getVuePage('Calendar/BatchDischarge/BatchDischarge')).default;
const GenerateVisitReminder = async () => (await getVuePage('Calendar/GenerateVisitReminder')).default;

const Worklist = async () => (await getVuePage('Worklist/Worklist')).default;
const VisitWorkflow = async () => (await getVuePage('Workflow/VisitWorkflow')).default;
const PatientDashboard = async () =>
    (await getVuePage('PatientDashboard/PatientDashboard')).default;
const CustomScansLandingPage = async () => 
    (await getVueModule('PatientDashboard/LandingPages/CustomScans/CustomScans')).default;
const InsuranceLandingPage = async () =>
    (await getVueModule('PatientDashboard/LandingPages/Insurance/Insurance')).default;
const SmartAppLaunch = async () => (await getVueModule('PatientDashboard/QuickActionsMenu/FhirSmartApps/SmartAppLaunch')).default
const TreatmentCyclesLandingPage = async () =>
    (await getVueModule('PatientDashboard/LandingPages/TreatmentCycles/TreatmentCyclesLandingPage')).default;
const FotoLandingPage = async () =>
    (await getVueModule('PatientDashboard/LandingPages/FOTO/FotoLanding')).default;
const ReviewDemographicsChanges = async () =>
    (await getVueModule('PatientDashboard/ReviewDemographicsChanges/ReviewDemographicsChanges')).default;
const VisitsAndDocumentationLandingPage = async () =>
    (await getVueModule('PatientDashboard/LandingPages/VisitsAndDocumentation/VisitsAndDocumentation')).default;
const ManagementBoard = async () =>
    (await getVuePage('ManagementBoard/ManagementBoard')).default;
const NHSAdmin = async () => (await getVuePage('NHSAdmin/NHSAdmin')).default;
const FotoReportingAdmin = async () =>
    (await getVuePage('NHSAdmin/FOTOReporting/FotoReporting')).default;
const FotoReportingYearAdmin = async () =>
    (await getVuePage('NHSAdmin/FOTOReporting/FotoReportingYearAdmin')).default;
const FacilityAdmin = async () =>
    (await getVuePage('FacilityAdmin/FacilityAdmin')).default;
const PatientHistoryAdmin = async () =>
    (await getVuePage('FacilityAdmin/PatientHistory/PatientHistory')).default;
const SuperbillAdmin = async () =>
    (await getVuePage('FacilityAdmin/Superbill/Superbill')).default;
const DocumentEditor = async () =>
    (await getVuePage('DocumentEditor/DocumentEditor')).default;
const DocumentViewer = async () =>
    (await getVuePage('DocumentViewer/DocumentViewer')).default;
const STCConfiguration = async () =>
    (await getVuePage('FacilityAdmin/STCConfiguration/STCConfiguration')).default;
const EligibilityPayerConfiguration = async () =>
    (await getVuePage('FacilityAdmin/EligibilityPayerConfiguration/EligibilityPayerConfiguration')).default;
const ClaimRules = async () =>
    (await getVuePage('FacilityAdmin/ClaimRules/ClaimRules')).default;
const FacilityVisitTypeAdmin = async () =>
    (await getVuePage('FacilityAdmin/FacilityVisitType/FacilityVisitTypeAdmin')).default;
const PatientEligibilityReport = async () =>
    (await getVuePage('Billing/PatientEligibility/PatientEligibilityReport')).default;
const LearnMore = async () =>
    (await getVuePage('AdvancedLab/LearnMore')).default;
const PatientEligibilityResults = async () =>
    (await getVuePage('Reports/PatientEligibility/PatientEligibilityResults')).default;
const ComparePatientEligibilityReport = async () =>
    (await getVuePage('Billing/PatientEligibility/ComparePatientEligibilityReport')).default;
const ComparePatientEligibilityResults = async () =>
    (await getVuePage('Reports/PatientEligibility/ComparePatientEligibilityResults')).default;
const PatientEligibilityDetailReport = async () =>
    (await getVuePage('Reports/PatientEligibility/PatientEligibilityReport')).default;
const PatientStatement = async () =>
    (await getVuePage('Billing/PatientStatement/PatientStatement')).default;
const CmsAutoTransmissionAdmin = async () => (await getVuePage('NHSAdmin/CMS/AutoTransmissionAdmin')).default;
const FacilityCmsAutoTransmissionAdmin = async () => (await getVuePage('FacilityAdmin/CMS/AutoTransmissionAdmin')).default;
const IdpAdmin = async () => (await getVuePage('NHSAdmin/Authentication/IdpAdmin')).default;
const IdpRoleAdmin = async () => (await getVuePage('NHSAdmin/Authentication/IdpRoleAdmin')).default;
const PatientEligibilityVerificationReportByLocation = async () =>
    (await getVuePage('Billing/PatientEligibility/PatientEligibilityVerificationReportByLocation')).default;
const FacilityProviderPinsCredentialSettings = async () =>
    (await getVuePage('FacilityAdmin/FacilityProviderPins/FacilityProviderPinsCredentialSettings')).default;
const VisitAuthorshipLog = async () => (await getVuePage('VisitAuthorshipLog/VisitAuthorshipLog')).default;
const PatientInsuranceAuditLog = async () => (await getVuePage('AuditLog/PatientInsuranceAuditLog')).default;
const ClaimHoldAuditReport = async () => (await getVuePage('AuditLog/ClaimHoldAuditReport')).default;

const BillingCompliance = async () =>
    (await getVuePage('FacilityAdmin/BillingCompliance/BillingCompliance')).default;

const PayerRules = async () =>
    (await getVuePage('FacilityAdmin/PayerRules/PayerRules')).default;

const TissueAnalyticsEmbed = async () => (await getVuePage('Reports/TissueAnalyticsEmbed')).default;

const FaxingAdmin = async () => (await getVuePage('NHSAdmin/Faxing/FaxingAdmin')).default;
const FaxingInbox = async () => (await getVuePage('Calendar/Faxing/FaxingInbox')).default;
const OutboundFaxing = async () => (await getVuePage('Calendar/Faxing/OutboundFaxing')).default;
const CacheAdmin = async () => (await getVuePage('NHSAdmin/CacheAdmin/CacheAdmin')).default;
const ReputationManagementAdmin = async () => (await getVuePage('NHSAdmin/PatientEngagementAdmin/ReputationManagement')).default;
const BillingFacilityGroup = async () => (await getVuePage('NHSAdmin/BillingFacilityGroup/BillingFacilityGroup')).default;
const BillingPayerAdmin = async () => (await getVuePage('NHSAdmin/BillingPayerAdmin/BillingPayerAdmin')).default;

const TransportationAgency = async () => (await getVuePage('FacilityAdmin/Transportation/TransportationAgency')).default;

const PatientStatementConfiguration = async () =>
    (await getVuePage('Billing/FacilityGroupStatementSetup/PatientStatementConfiguration')).default;

const ProgressNoteConfig = async () => (await getVuePage('MyProfile/ProgressNote/ProgressNoteConfig')).default;
const PatientStatementSetting = async () => (await getVuePage('Billing/PatientStatementSetting/PatientStatementSetting')).default;

const MultipleClaimsTransactionEdit = async () => (await getVuePage('Billing/Accounting/Transactions/MultipleClaimsTransactionEdit')).default;

const InteroperabilityIntegrationsAdmin = async () => (await getVuePage('NHSAdmin/Interoperability/InteroperabilityIntegrationsAdmin')).default;
const MyReportsTemplate = async () => (await getVuePage('Reports/MyReports/MyReportsTemplate')).default;
const PowerBIReports = async () => (await getVuePage('Reports/MyReports/PowerBIReports')).default;
const LegacyReports = async () => (await getVuePage('Reports/MyReports/LegacyReports')).default;
const ConnectionsDashboard = async () => (await getVuePage('MyProfile/WoundQ/ConnectionsDashboard')).default;
const WoundQConnections = async () => (await getVueModule('Workflow/VisitActions/WoundQ/WoundQConnections')).default;
const WoundQConnectionsAdmin = async () =>
    (await getVuePage('FacilityAdmin/WoundQ/WoundQConnectionsAdmin')).default;

const patientDashboardRoutes = [
    {
        path: '/patientDashboard/:patientId',
        component: PatientDashboard,
        props: true,
        children: [
            {
                name: Routes.PatientDashboard,
                path: '',
                component: KnockoutPage,
                props: (route) => {
                    return {
                        componentName: 'patientDashboard-widgetPanel',
                        folder: 'PatientDashboard/WidgetPanel',
                        page: 'WidgetPanel',
                        params: {
                            patientId: route.params['patientId'] ? ko.observable(decodeURIComponent(route.params['patientId'])) : ko.observable()
                        },
                        isModulePage: true
                    };
                }
            },
            {
                path: 'treatmentcycles',
                component: TreatmentCyclesLandingPage,
                props: true
            },
            {
                path: 'insuranceauth',
                component: InsuranceLandingPage,
                props: true
            },
            {
                path: 'customscans',
                component: CustomScansLandingPage,
                props: true
            },
            {
                path: 'SmartAppLaunch',
                component: SmartAppLaunch,
                props: true
            },
            {
                path: 'fotoLanding',
                component: FotoLandingPage,
                props: true
            },
            {
                path: 'reviewDemographicsChanges',
                component: ReviewDemographicsChanges,
                props: true
            },
            {
                path: 'visitsAndDocumentation',
                component: VisitsAndDocumentationLandingPage,
                props: true
            },
            {
                name: Routes.PatientStatementSettings,
                path: 'billing/patientStatementSettings',
                component: PatientStatementSetting,
                props:true,
                beforeEnter: async (to, from, next) => {
                    const allowed = await FeatureToggleService.checkFeatureToggle(AccessTypes.FeatureToggles.BillingPatientStatementRefactor2, false);
                    allowed ? next() : next({ path: 'billing-patientstatementsettings' });
                }
            },
            {
                path: ':page',
                name: 'ko-dashboard-page',
                component: KnockoutPage,
                props: (route) => {
                    const page = route.params['page'];
                    return {
                        componentName: 'page-patientDashboard-' + page,
                        folder: 'PatientDashboard/LandingPages/' + page,
                        page: page,
                        params: {
                            patientId: route.params['patientId'] ? ko.observable(decodeURIComponent(route.params['patientId'])) : ko.observable()
                        },
                        isModulePage: true
                    };
                }
            }
        ]
    },
];

const routes = [
    {
        name: Routes.MultipleClaimsTransactionEdit,
        path: '/Billing/Accounting/Transactions/MultipleClaimsTransactionEdit',
        component: MultipleClaimsTransactionEdit
    },
    ...patientDashboardRoutes,
    ...BillingRouteConfigs,
    {
        name: Routes.ClaimHoldAuditReport,
        path: '/auditlog/claimholdauditreport/:patientName?/:claimId?',
        component: ClaimHoldAuditReport,
        meta: {
            activeIcon: 'Facility Admin'
        }
    },
    {
        name: Routes.PatientInsuranceAuditReport,
        path: '/auditlog/patientinsuranceauditlog/:patientId?/:insuranceId?/:policySeq?',
        component: PatientInsuranceAuditLog,
        meta: {
            activeIcon: 'Facility Admin'
        }
    },
    {
        name: Routes.ClinicianWorklist,
        path: '/clinician/:clinicianId?/worklist',
        component: Worklist,
        meta: {
            activeIcon: 'Worklist'
        }
    },
    {
        name: Routes.Workflow,
        path: '/workflow/query',
        component: VisitWorkflow,
        props: (route) => ({
            visitId: route.query.visitId,
            documentType: route.query.hasOwnProperty('docType') ? route.query.docType : route.query.documentType,
            editor: route.query.hasOwnProperty('workFlowEditor') ? route.query.workFlowEditor : route.query.workfloweditor,
            tab: route.query.tab,
            patientId: route.query.patientId,
            treatmentCycleId: route.query.treatmentCycleId
        })
    },
    {
        name: Routes.Scheduler,
        path: '/scheduler',
        component: Scheduler,
        meta: {
            activeIcon: 'Calendar'
        }
    },
    {
        name: Routes.ManagementBoard,
        path: '/managementBoard',
        component: ManagementBoard,
        meta: {
            activeIcon: 'Management Board'
        }
    },
    {
        path: '/document/:documentType',
        name: 'DocumentEditor',
        component: DocumentEditor
    },
    {
        path: '/documentViewer/:documentId?/:documentType?',
        name: 'DocumentViewer',
        component: DocumentViewer,
        props: (route) => ({
            documentId: route.params.documentId,
            documentType: route.params.documentType
        })
    },
    {
        name: 'VisitAuthorshipLog',
        path: '/VisitAuthorshipLog',
        component: VisitAuthorshipLog,
        props: (route) => ({
            visitId: route.query.VisitID,
            patientId: route.query.PatientID,
        }),
        meta: {
            title: 'Visit Authorship Log'
        }
    },
    {
        path: '/nhsAdmin',
        component: NHSAdmin,
        meta: {
            activeIcon: 'NHS Admin'
        },
        beforeEnter: async (to, from, next) => {
            const allowed = await AccessService.authorize(AccessTypes.Navigation.NHS_ADMIN);
            allowed ? next() : next(false);
        },
        children: [
            {
                path: 'fotoReporting',
                component: FotoReportingAdmin
            },
            {
                path: 'fotoReportingYear',
                component: FotoReportingYearAdmin
            },
            {
                path: 'cms/automaticTransmissionAdmin',
                component: CmsAutoTransmissionAdmin
            },
            {
                path: 'authentication/idpAdmin',
                component: IdpAdmin
            },
            {
                path: 'authentication/idpRoleAdmin',
                component: IdpRoleAdmin
            },
            {
                path: 'interoperabilityIntegrationsAdmin',
                component: InteroperabilityIntegrationsAdmin
            },
            {
                path: 'FaxingAdmin',
                component: FaxingAdmin,
                meta: {
                    title: 'Faxing Admin'
                }
            },
            {
                path: 'patientEngagement/reputationManagement',
                component: ReputationManagementAdmin
			},
			{
				path: 'billingFacilityGroup',
				component: BillingFacilityGroup
            },
            {
                path: 'billingPayerAdmin',
                component: BillingPayerAdmin
            },
            {
                path: 'redisCacheAdmin',
                component: CacheAdmin
            },
            {
                path: ':page?/:item?',
                component: KnockoutPage,
                props: (route) => {
                    const page = route.params['page'] ? route.params['page'] : 'users'; // default to users
                    return {
                        componentName: 'page-nhsAdmin-' + page,
                        folder: 'NHSAdmin/' + page,
                        page: page,
                        params: { item: route.params['item'] }
                    };
                }
            }
        ]
    },
    {
        path: '/facilityAdmin',
        component: FacilityAdmin,
        meta: {
            activeIcon: 'Facility Admin'
        },
        children: [
            {
                name: 'facilityProviderPins',
                path: 'facilityProviderPins',
                component: FacilityProviderPinsCredentialSettings,
                props: (route) => ({
                    billingProviderId: route.query.billingProviderId,
                    providerId: route.query.providerId,
                    claimId: route.query.claimId,
                    insurancePlanId: route.query.insurancePlanId,
                    facilityId: route.query.facilityId,
                })
            },
            {
                path: 'cms/automaticTransmissionAdmin',
                component: FacilityCmsAutoTransmissionAdmin
            },
            {
                path: 'patientHistory',
                component: PatientHistoryAdmin
            },
            {
                path: 'superbill',
                component: SuperbillAdmin
            },
            {
                path: 'stcConfiguration',
                component: STCConfiguration
            },
            {
                path: 'eligibilityPayerConfiguration',
                component: EligibilityPayerConfiguration
            },
            {
                path: 'claimRules',
                component: ClaimRules
            },
            {
                path: 'billingCompliance',
                component: BillingCompliance
            },
            {
                path: 'payerRuleAdmin',
                component: PayerRules
            },
            {
                path: 'transportationAgency',
                component: TransportationAgency
            },
            {
                name: 'patientStatementsConfiguration',
                path: 'patientStatementsConfiguration',
                component: PatientStatementConfiguration,
            },
            {
                // legacy visit type admin page
                path: 'visitTypeAdmin/WoundCare',
                component: KnockoutPage,
                props: () => {
                    return {
                        componentName: 'page-facilityAdmin-visitTypeAdmin',
                        folder: 'Modules/FacilityAdmin/VisitTypeAdmin',
                        page: 'VisitTypeAdmin'
                    };
                }
            },
            {
                path: 'visitTypeAdmin',
                component: FacilityVisitTypeAdmin
            },
            {
                path: 'woundQConnectionsAdmin',
                component: WoundQConnectionsAdmin
            },
            {
                path: ':page?/:item?',
                component: KnockoutPage,
                props: (route) => {
                    const page = route.params['page'] ? route.params['page'] : 'patientList'; // default to patient search
                    return {
                        componentName: 'page-facilityAdmin-' + page,
                        folder: 'Modules/FacilityAdmin/' + page,
                        page: page,
                        params: { item: route.params['item'] }
                    };
                }
            }
        ]
    },
    {
        path: '/calendar/colorCodingAdmin',
        component: ColorCodingAdmin,
        meta: {
            activeIcon: 'Calendar'
        }
    },
    {
        path: '/calendar/schedulerFacilitySettings',
        component: SchedulerFacilitySettings,
        meta: {
            activeIcon: 'Calendar'
        }
    },
    {
        path: '/calendar/batchPrintDashboard',
        component: BatchPrintDashboard,
        meta: {
            activeIcon: 'Calendar'
        }
    },
    {
        path: '/calendar/batchDischarge',
        component: BatchDischarge,
        meta: {
            activeIcon: 'Calendar'
        }
    },
    {
        path: '/generateVisitReminder',
        component: GenerateVisitReminder,
        props: (route) => ({
            patientId: route.query.patientId,
            facilityId: route.query.facilityId,
            allVisits: route.query.allVisits,
            isNew: route.query.isNew,
            currentSelectedVisitDate: route.query.currentSelectedVisitDate,
            currentSelectedVisitTime: route.query.currentSelectedVisitTime,
            clinicianId: route.query.clinicianId,
            physicianId: route.query.physicianId
        })
    },
    {
        name:'PatientEligibilityReport',
        path: '/PatientEligibilityReport',
        component: PatientEligibilityReport,
        meta: {
            title: 'Patient Eligibility Results'
        }
    },
    {
        name: 'PatientEligibilityResults',
        path: '/PatientEligibilityResults',
        component: PatientEligibilityResults,
        meta: {
            title: 'Patient Eligibility Results'
        }
    },
    {
        name: 'ComparePatientEligibilityReport',
        path: '/ComparePatientEligibilityReport',
        component: ComparePatientEligibilityReport,
        meta: {
            title: 'Compare Patient Eligibility Results'
        }
    },
    {
        name: 'ComparePatientEligibilityResults',
        path: '/ComparePatientEligibilityResults',
        component: ComparePatientEligibilityResults,
        meta: {
            title: 'Compare Patient Eligibility Results'
        }
    },
    {
        name: 'PatientEligibilityDetailReport',
        path: '/PatientEligibilityDetailReport',
        component: PatientEligibilityDetailReport,
        meta: {
            title: 'Patient Eligibility Results'
        }
    },
    {
        name: 'PatientStatement',
        path: '/PatientStatement',
        component: PatientStatement,
        meta: {
            title: 'Patient Statement'
        },
        props: route => ({
            statementBatchId: route.query?.statementBatchId,
            statementBatchPartNumber: route.query?.statementBatchPartNumber,
            accountNumber: route.query?.accountNumber,
            cptDisplayType: route.query?.cptDisplayType,
            statementLineGroupByType: route.query?.statementLineGroupByType,
            includePaidLines: route.query?.includePaidLines,
            dateFrom: route.query?.dateFrom,
            dateTo: route.query?.dateTo,
            patientStatementId: route.query?.patientStatementId,
            patientStatementServiceGenerated: route.query?.patientStatementServiceGenerated
        })
    },
    {
        name: 'PatientEligibilityVerificationReportByLocation',
        path: '/PatientEligibilityVerificationReportByLocation',
        component: PatientEligibilityVerificationReportByLocation,
        meta: {
            title: 'Patient Eligibility Verification Report by Location'
        }
    },
    {
        name: 'TissueAnalyticsEmbed',
        path: '/TAEmbed',
        component: TissueAnalyticsEmbed,
        props: route => ({
            patientId: route.query.patientId,
            woundId: route.query.woundId,
            visitId: route.query.visitId,
        })
    },
    {
        name: 'LearnMore',
        path: '/LearnMore',
        component: LearnMore,
        meta: {
            title: 'Learn More'
        }
    },
    {
        path: '*',
        component: NotFound
    },
    {
        name: 'FaxingInbox',
        path: '/faxing/inbox/:query?',
        component: FaxingInbox,
        meta: {
            title: 'Inbound Faxing'
        },
        props: route => ({
            isWorklist: decodeURIComponent (route.query.MenuTabSectionID) === "zSLAX4JomnQ=",
        })
    },
    {
        name: 'OutboundFaxing',
        path: '/faxing/outbound/:query?',
        component: OutboundFaxing,
        meta: {
            title: 'Outbound Faxing'
        },
        props: route => ({
            isWorklist: decodeURIComponent (route.query.MenuTabSectionID) === "zSLAX4JomnQ=",
            visitId: route.query.VisitId,
            faxIds: route.query.faxIds?.split(','),
        })
    },
    {
        name: 'ProgressNoteConfig',
        path: '/my-profile/ProgressNoteConfig',
        component: ProgressNoteConfig       
    },
    {
        path: '/myReports',
        component: MyReportsTemplate,
        meta: {
            activeIcon: 'My Reports'
        }
    },
    {
        path: '/myReports/powerBIReports',
        component: PowerBIReports,
        meta: {
            activeIcon: 'My Reports'
        },
        props: (route) => ({
            guid: route.query.guid,
            reportTitle: route.query.reportTitle,
            reportName: route.query.reportName
        }),
        beforeEnter: async (to, from, next) => {
            const allowed = await FeatureToggleService.checkFeatureToggle(AccessTypes.FeatureToggles.PowerBI, false);
            allowed ? next() : next({ path: '/reports'});
        }
    },
    {
        path: '/myReports/legacyReports',
        component: LegacyReports,
        meta: {
            activeIcon: 'My Reports'
        },
        props: (route) => ({
            legacyUrl: route.query.legacyUrl,          
        }),
    },
    {
        name: 'ConnectionsDashboard',
        path: '/WoundQ/ConnectionsDashboard',
        component: ConnectionsDashboard
    },
    {
        name: 'WoundQConnections',
        path: '/WoundQ/WoundQConnections',
        component: WoundQConnections,
        props: route => ({
            visitId: route.query.VisitId,
            patientId: route.query.PatientId
        })
    }
];

const router = new VueRouter({
    routes: routes
});

router.afterEach((to, from) => {
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    }
    // if navigating to workflow, increase count
    // if navigating away from workflow, decrease count
    // else get / set initial value when page first loads
    if (to.name === 'workflow' && from.name !== 'workflow') {
        VueRootStore.dispatch('alterDocumentationTabCount', true);
    } else if (from.name === 'workflow' && to.name !== 'workflow') {
        VueRootStore.dispatch('alterDocumentationTabCount', false);
    } else {
        VueRootStore.dispatch('setDocumentationTabCount');
    }
});

export default router;
